import React from 'react'
import styles from './JoinTeamModalTeamCard.module.css';

const JoinTeamModalTeamCard = (props) => {
    const team = props.team;
    // console.log(props.isSelected)
    const clickHandler = () => {
        if (props.isSelected) {
            props.setSelectedId("0")
        }
        else {
            props.setSelectedId(team.id)
        }
    }
    return (
        <div
            className={`${styles.JoinTeamModalTeamCard} ${props.isSelected ? styles.JoinTeamModalTeamCardSelected : ""}`}
            onClick={clickHandler}
        >
            <h5>{team.team_number ? `#${team.team_number} - ` : ""}{team.name}</h5>
            <p className='m-1' >Missing Count: {team.missing_count}</p>
            <div className={styles.members} >
                {
                    team?.team_members?.map(team_member => <p key={team_member} className={styles.member}  >{team_member}</p>)
                }
            </div>
        </div>
    )
}

export default JoinTeamModalTeamCard
